import { createAction, props } from '@ngrx/store';

export const increment = createAction('increment');
export const decrement = createAction('decrement');
export const reset = createAction('reset');
export const AddData = createAction('addData', props<{ value: number }>());

export const loadData = createAction('[API] Load Data');
export const loadDataSuccess = createAction('[API] Load Data Success', props<{ data: any }>());
export const loadDataError = createAction('[API] Load Data Error', props<{ error: any }>());
